import { getRewardCenterStatusQueryClient } from "@workspace/casino_core/queries/RewardCenterStatusQuery.client";
import type { Status } from "../rewardCenter/types";
import { IS_MOCK } from "./mock";

const MOCK = {
  loyaltyPublic: {
    id: "MOCK_EXAMPLE",
    myStatus: {
      currentTier: {
        id: "TG95YWx0eVB1YmxpY1VzZXJUaWVyOjE0",
        level: 2,
        progress: 2.5367156208277706,
      },
    },
  },
};
const fetchMyStatus = async (site: string): Promise<Status | undefined> => {
  try {
    const { data } = await getRewardCenterStatusQueryClient({ site });

    if (IS_MOCK) {
      if (Math.floor(Math.random() * 10) === 7) {
        throw new Error("Simulate failing");
      }
      return MOCK as unknown as Status;
    }

    return data?.loyaltyPublic ?? undefined;
  } catch (error) {
    console.warn("[actors] fetching my status failed", error);
    return undefined;
  }
};

export default fetchMyStatus;
